import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { mumulLiveService } from 'shared/src/api';
import { useIsMumulLiveExposed } from '../hooks/useIsMumulLiveExposed';

/**
 * 무물라이브 프로필 상태 조회.
 * 무물라이브 노출 대상(EXP1788 B군)이고 `profileSno`(market.mumul_live_profile_sno)가
 * 있을 때만 호출한다.
 */
export const useMumulLiveProfileStatus = (profileSno: number | null) => {
  const isExposed = useIsMumulLiveExposed();

  return useQuery({
    queryKey: queryKey.mumulLiveProfileStatus(profileSno ?? 0),
    queryFn: () =>
      mumulLiveService.getMumulLiveProfileStatus(profileSno as number),
    enabled: isExposed && profileSno != null,
  });
};
